import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * Helper class to manage registering destroy listeners for popup handles.
 * If the backing destroyListenerMgr is destroyed (via 'destroyAll'), then all current registered popups
 * will be closed and unregistered.
 */
// Do NOT subclass DestroyListenerMgr as that should be single backing store for all types of destroy listeners
// (e.g., Popup, close, teardown, destroy, machine) across all layers of the app (model, service, ui, dto, ...).
// As such, (single) inheritance is not appropriate, so support popup destroy via composition (this class) instead.
export class PopupRegistryImpl {
  /**
   * Create a PopupRegistryImpl that is backed by the given destroyListenerMgr.
   * It is automatically torn down when the owner.destroyAll method is invoked
   * (e.g., for component unmount (BaseRCmp.pipelineRegistry),
   * or for major route changes (AbstractRouteHandler.pipelineRegistry))
   * @param owner
   */
  constructor(owner) {
    _defineProperty(this, "popupHandleSet", new Set());
    this.owner = owner;
  }

  /**
   * Registers popup with backing destroyListenerMgr.
   */
  registerPopup(popupHandle) {
    // Use registerDestroyListener so that popups and other 'disposers' are invoked in the reverse order
    // that they are registered (previously invoked all disposers, then closed all popups, which can potentially have
    // ordering problems)
    if (this.popupHandleSet.has(popupHandle)) {
      return;
    }
    const registeredCloseFn = this.owner.registerDestroyListener(() => popupHandle.close());
    this.popupHandleSet.add(popupHandle);

    // Auto-unregister on close
    popupHandle.untilClosed.then(() => {
      // These are no-ops if underlying registries are already removed
      this.popupHandleSet.delete(popupHandle);
      this.owner.removeAsyncDestroyListener(registeredCloseFn);
    });
  }
}
//# sourceMappingURL=PopupRegistryImpl.js.map
